import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux"; // Assuming you're using Redux
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import Input from "../../../components/ui/Input";
import Select from "../../../components/ui/Select";
import { getClientsService } from "../../../redux/services/clients_service";
import {
  assignOrderService,
  getOrdersService,
} from "../../../redux/services/orders_service";
import { getAreaByGovService } from "../../../redux/services/general_service";
import { toast } from "react-toastify";

const EditOrderModal = ({ order, onClose, onUpdateOrder }) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
   // delivery_agent_id: order?.delivery_agent?.enc_id || "",
    order_date: order?.order_date || "",
  //  delivery_date: order?.delivery_date || null,
    order_status: order?.order_status || "",
    order_type: order?.order_type || "",
    discount: order?.discount || 0,
    notes: order?.notes || "",
    address: order?.address || "",
    area_id: order?.area_id || "",
  });
  const [agents, setAgents] = useState([]);
  const [areas, setAreas] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch agents and areas on mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        const agentsResponse = await dispatch(
          getClientsService({ page: 1, role: "AGENT" })
        );

        setAgents(agentsResponse?.payload?.data?.data?.data);

        const areasResponse = await dispatch(
          getAreaByGovService({ governorate_id: 1 })
        ); // Adjust as needed
        setAreas(areasResponse?.payload?.data?.data?.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [dispatch]);

  const agentOptions = agents.map((agent) => ({
    value: agent?.enc_id,
    label: `${agent.first_name}  ${agent.last_name}`,
  }));

  const areaOptions = areas?.map((area) => ({
    value: area.id,
    label: area.name,
  }));

  const statusOptions = [
    { value: 1, label: "تم الإنشاء" },
    { value: 2, label: "تم التحضير" },
    { value: 3, label: "قيد التسليم" },
    { value: 4, label: "تم التسليم" },
    { value: 5, label: "مكتمل" },
    { value: 6, label: "ملغي" },
  ];

  const typeOptions = [
    { value: 1, label: "مباشر" },
    { value: 2, label: "غير مباشر" },
  ];

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await dispatch(assignOrderService({ id: order.id, data: formData })).then(
        (response) => {
          console.log(response?.payload);
          if (response?.payload?.status == 200) {
            onUpdateOrder();
            onClose();
            toast("تم التعديل بنجاح");
            dispatch(getOrdersService());
          } else{
   if (response?.payload?.errors) {
            Object.values(response.payload.errors)

              .flatMap((errorArray) => errorArray)

              .forEach((error) => toast.error(error));
          } else if (response?.payload?.message) {
            toast.error(response.payload.message);
          } else {
            toast.error("حدث خطأ غير معروف");
          }
          }

       
        }
      );
    } catch (error) {
      console.error("Error updating order:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {}, [agents, areas]);
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-elevation-3 w-full max-w-2xl max-h-[90vh] overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div className="flex items-center space-x-3">
            <Icon name="Edit" size={24} className="text-primary" />
            <div>
              <h2 className="text-xl font-semibold text-foreground">
                تعديل الطلب
              </h2>
              <p className="text-sm text-muted-foreground">
                تحديث تفاصيل الطلب
              </p>
            </div>
          </div>

          <Button variant="ghost" size="icon" onClick={onClose}>
            <Icon name="X" size={20} />
          </Button>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto max-h-[60vh]">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Select
              label="المندوب"
              placeholder="اختر مندوب"
              options={agentOptions}
              value={formData.delivery_agent_id}
              onChange={(value) => handleChange("delivery_agent_id", value)}
            />

            <Input
              label="تاريخ الطلب"
              type="datetime-local"
              value={formData.order_date}
              onChange={(e) => handleChange("order_date", e.target.value)}
            />

            <Input
              label="تاريخ التسليم"
              type="datetime-local"
              value={formData.delivery_date}
              onChange={(e) => handleChange("delivery_date", e.target.value)}
            />

            <Select
              label="حالة الطلب"
              options={statusOptions}
              value={formData.order_status}
              onChange={(value) => handleChange("order_status", value)}
            />

            <Select
              label="نوع الطلب"
              options={typeOptions}
              value={formData.order_type}
              onChange={(value) => handleChange("order_type", value)}
            />

            <Input
              label="الخصم"
              type="number"
              value={formData.discount}
              onChange={(e) =>
                handleChange("discount", parseFloat(e.target.value) || 0)
              }
            />

            <Select
              label="المنطقة"
              placeholder="اختر منطقة"
              options={areaOptions}
              value={formData.area_id}
              onChange={(value) => handleChange("area_id", value)}
            />

            <div className="md:col-span-2">
              <Input
                label="العنوان"
                value={formData.address}
                onChange={(e) => handleChange("address", e.target.value)}
              />
            </div>

            <div className="md:col-span-2">
              <label className="block text-sm font-medium text-foreground mb-2">
                الملاحظات
              </label>

              <textarea
                value={formData.notes}
                onChange={(e) => handleChange("notes", e.target.value)}
                rows={3}
                className="w-full px-3 py-2 border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                placeholder="أضف أي ملاحظات..."
              />
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-between p-6 border-t border-border bg-muted/30">
          <Button
            variant="outline"
            onClick={onClose}
            iconName="X"
            iconPosition="left"
          >
            إلغاء
          </Button>

          <Button
            variant="default"
            onClick={handleSubmit}
            disabled={loading}
            iconName="Check"
            iconPosition="left"
          >
            {loading ? "جاري التحديث..." : "تحديث الطلب"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EditOrderModal;
